import Loadable from "react-loadable";

export const AddOfferButton = Loadable({
  loader: () =>
    import("../../../../modules/manage-marketplace").then((module) => module.AddOfferButton) as Promise<any>,
  loading: () => null,
});
